export default "__VITE_ASSET__d040add6__"